import React, { useContext } from "react";
import SidePanel from "components/side-panel";
import translations from "locales";
import * as styles from "./style.mod.scss";
import GlobalContext from "services/global-context";
import Loader from "components/loader";

const LoadingCart = ({ showRecommendations }) => {
  const { cartOpened, toggleCart } = useContext(GlobalContext);

  return (
    <SidePanel
      title={translations?.cart?.yourEmptyCart}
      open={cartOpened}
      onClose={toggleCart}
      className={`${styles.empty} ${styles.cart} 
    ${!showRecommendations ? `${styles.reducePanelWidth}` : "small-cart"}`}
      bodyClass={styles.body}
      closeIconStyle={styles.closeIcon}
    >

      <Loader width="100%" />
    </SidePanel>
  );
};
export default LoadingCart;